export default __webpack_public_path__ + "static/media/Sage's Armbands of the Crumbling Tower.eb1eed82.jpg";